var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCasesInovacao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 69.1 71.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.7,68.3c2.5,2.5,6.6,2.5,9.1,0l23.9-23.9c11.2,6.2,25.3,2.2,31.5-9,6.2-11.2,2.2-25.3-9-31.5-11.2-6.2-25.3-2.2-31.5,9-3.9,7-3.9,15.5,0,22.5L.7,59.3M3.5,64.2l27.9-27.8s-7.9-13.7.2-23c10.2-11.7,22.2-2.6,22.2-2.6M45.3,28.6v9.6M50.1,33.5h-9.6M49.3,19.7v9.7M54.2,24.5h-9.7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCasesInovacao);
export default __webpack_public_path__ + "static/media/cases-inovacao.ddaa54472209911d8bc9131de4c6b128.svg";
export { ForwardRef as ReactComponent };